import { put, call } from 'redux-saga/effects';
import { PostAction,UIAction } from '../actions';
import { PostService } from '../services';
import { generateReadableError } from 'hooks';


export function* getReportPosts(action) {
  //yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().fetchReportPost, action.payload);
    yield put(PostAction.getReportPostsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(PostAction.getReportPostsSuccess(null));
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getSearches(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().fetchSearches, action.payload);
    yield put(PostAction.getSearchSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getFavourites(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().fetchFavourites, action.payload);
    yield put(PostAction.getFavouritesSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* getReportedBy(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().fetchReportedBy, action.payload);
    yield put(PostAction.reportedBySuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getViewedBy(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().fetchViewedBy, action.payload);
    yield put(PostAction.viewedBySuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}

export function* getPostDetails(action) {

  
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().fetchPostDetails, action.payload);
    yield put(PostAction.getPostDetailsSuccess(data));
    yield put(UIAction.showLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showLoading(false));
  }
}


export function* deletePost(action) {
  yield put(UIAction.showMessages(null));
  yield put(UIAction.showMainLoading(true));
  try {
    const {data}  = yield call(PostService.getInstance().deletePost, action.payload);
    yield put(PostAction.deletePostSuccess(data));
    yield put(UIAction.showMessages({ status: 'success', message: data.responseMessage }));
    yield put(UIAction.showMainLoading(false));
  }
  catch (e) {
    yield put(UIAction.showMessages(generateReadableError(e)));
    yield put(UIAction.showMainLoading(false));
  }
}





